import { AiChat, AiMessage, ApiAiChatResponse, ApiAiMessageResponse } from 'model/modules/chatAi/chatAi';

import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';

export const mapAiMessageFromApi = (apiItem: ApiAiMessageResponse): AiMessage => {
  return {
    id: apiItem.external_id,
    createdAt: new Date(apiItem.create_timestamp * 1000),
    text: apiItem.text,
    isFromAi: apiItem.ai,
    attachment: apiItem.attachment ?? undefined,
  };
};

const mapAiMessageListFromApi = (
  resp: SharesproApiResponse< ApiPaginationListResponse<ApiAiMessageResponse>>
): PaginationList<AiMessage> => {
  return mapPaginationListFromApi<AiMessage, ApiAiMessageResponse>(
    resp.data,
    mapAiMessageFromApi
  );
};

export default mapAiMessageListFromApi;

export function mapAiChatFromApi(api: ApiAiChatResponse): AiChat {
  return {
    id: api.external_id,
    createdAt: new Date(api.create_timestamp * 1000),
    lastMessage: api.last_message ? mapAiMessageFromApi(api.last_message) : undefined,
  };
}
